<template>
  <basic-container>
    <Search />
    <Table />
  </basic-container>
</template>

<script>
import { observable } from "vue";
import { getProtocolNameFromDict, getProtocolList } from '@/api/protocolCompliance/protocolManage'
import Search from './components/search.vue'
import Table from './components/table.vue'
export default {
  name: 'WebSaaSIndex',
  components: {
    Search,
    Table
  },
  provide() {
    return {
      /** 搜索参数 */
      searchParams: this.searchParams,
      /** 协议数组 */
      protocolList: this.protocolList,
      /** 列表数据 */
      list: this.list,
      /** 搜索的方法 */
      loadList: this.loadList
    };
  },
  data() {
    return {
      /** 协议数组 */
      protocolList: observable({
        value: []
      }),
      searchParams: observable({
        /** 协议名称 */
        name: '',
        /** 发布状态 */
        status: '',
        current: 1,
        size: 10,
        total: 1,
      }),
      list: observable({
        value: [],
      })
    };
  },

  created() {
    this.getProtocolName()
    this.loadList()
  },
  methods: {
    /** 分页接口 */
    async loadList() {
      const { data } = await getProtocolList(this.searchParams)
      console.log('获取列表接口的响应', data);
      this.list.value = data.data.records
      this.searchParams.total = data.data.total
    },
    /** 获取业务字典中-协议名称的接口 */
    async getProtocolName() {
      const { data } = await getProtocolNameFromDict()
      console.log('业务字典中-协议名称的接口', data);
      this.protocolList.value = data.data.map(item => ({
        name: item.dictValue,
        code: Number(item.dictKey)
      }))
    },

    /** 从业务字典-获取协议地址 */
    // async getProtocolUrl() {
    //   const { data } = await getProtocolUrlFromDict()
    //   console.log('业务字典中-协议地址的接口', data);
    //   this.protocolList.value = this.protocolList.value.map((item, index) => {
    //     return {
    //       ...item,
    //       url: data.data[index].dictValue
    //     };
    //   });
    // },
  },
};
</script>

<style lang="scss" scoped></style>